import React, { Fragment, Component } from 'react'
import {
    Container, Row, Col, Button, Spinner,
} from "reactstrap"

import apiResponse from '../../../../../services/apiResponse'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/menuService'

import DetailBloc from '../Blocs/DetailBloc'
import OrganizationChart from '@dabeng/react-orgchart'
import NodeChart from './NodeChart'

class ChartComponent extends Component {

    source
    detailBloc = new DetailBloc()

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            detail: null,
            filename: 'orgchart',
            fileextension: 'png',
        }
        this.orgChart = React.createRef()
    }

    LoadingState = () => (
        <div style={{
            padding: "80px 0",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
        }}>
            <Spinner color="primary" style={{ width: "4rem", height: "4rem" }} />
            <h5 className="mt-4 text-muted">Mengambil data...</h5>
        </div>
    )

    EmptyState = () => (
        <div style={{
            padding: "80px 0",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "#6c757d"
        }}>
            <h5 className="mt-4">Tidak ada data</h5>
            <p className="text-muted">Silakan pilih unit kerja terlebih dahulu</p>
        </div>
    )

    loadHirarki = async () => {
        const query = {
            uuid: this.props.uuid,
            period: this.props.period
        }
        await this.detailBloc.fetchHirarki(query, this.source.token)
    }

    setTokenAPI = () => {
        this.setState({ loading: true, detail: null })
        if (typeof this.source !== typeof undefined) {
            this.source.cancel()
        }
        this.source = cancelToken()
        this.loadHirarki()
    }

    exportTo = () => {
        const { filename, fileextension } = this.state
        this.orgChart.current.exportTo(filename, fileextension)
    }

    onNameChange = event => {
        this.setState({ filename: event.target.value })
    }

    onExtensionChange = event => {
        this.setState({ fileextension: event.value })
    }

    /**
     * Force expand all nodes setelah chart render
     */
    expandAllNodes = () => {
        setTimeout(() => {
            const chartContainer = document.querySelector('.chart-container')
            if (!chartContainer) return

            // Hapus class 'isChildrenCollapsed' dari semua node
            const collapsedNodes = chartContainer.querySelectorAll('.oc-node.isChildrenCollapsed')
            collapsedNodes.forEach(node => {
                node.classList.remove('isChildrenCollapsed')
            })

            // Tampilkan semua edge yang hidden
            const hiddenEdges = chartContainer.querySelectorAll('.oc-edge.hidden, .bottomEdge.hidden')
            hiddenEdges.forEach(edge => {
                edge.classList.remove('hidden')
            })

            // Tampilkan semua children nodes
            const nodes = chartContainer.querySelectorAll('.oc-node')
            nodes.forEach(node => {
                node.style.display = ''
            })
        }, 100)
    }

    componentDidMount() {
        if (this.props.uuid) {
            this.setTokenAPI()
        }

        this.detailBloc.hirarkiChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({ loading: true })
                    break
                case apiResponse.COMPLETED:
                    this.setState({
                        detail: result.data.response.result,
                        loading: false
                    }, () => {
                        // Expand all setelah render
                        this.expandAllNodes()
                    })
                    break
                case apiResponse.ERROR:
                    this.setState({ loading: false })
                    break
                default:
                    break
            }
        })
    }

    componentDidUpdate(prevProps, prevState) {
        // Expand all setelah data berubah
        if (prevState.detail !== this.state.detail && this.state.detail) {
            this.expandAllNodes()
        }

        if (this.props.uuid && this.props.uuid !== prevProps.uuid) {
            this.setTokenAPI()
        }
    }

    componentWillUnmount() {
        this.detailBloc.hirarkiChannel?.unsubscribe()
    }

    render() {
        const { detail } = this.state

        if (this.state.loading) {
            return this.LoadingState()
        }
        if (!this.state.loading && !this.state.detail) {
            return this.EmptyState()
        }

        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col md="12">
                            <Row className="mb-3">
                                <Col md="12" className="text-end">
                                    <Button color="primary" onClick={this.exportTo}>
                                        <i className="mdi mdi-download me-1"></i>
                                        Export Chart
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col md="12" className="chart-container">
                            <OrganizationChart
                                chartClass="myChart"
                                datasource={detail}
                                NodeTemplate={NodeChart}
                                collapsible={true} 
                                pan={true}
                                zoom={true}
                                ref={this.orgChart}
                            />
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

export default ChartComponent